import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { getOrgToken } from './modules'
import Loading from 'components/Loading'
import { queryNotice, getAppSalt } from 'store/siteConfig'

export default function(route) {
  const Cybersource = Loadable({
    loader: () => import('./Cybersource'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          paymentsCybersourceState: state.paymentsCybersourceState,
          siteConfig: state.siteConfig,
        }),
        {
          getOrgToken,
          getAppSalt,
          queryNotice,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/cybersource`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Cybersource {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
